import React, { Component } from "react";
import "./calendar.module.css";
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
} from "../../services/fetchTools";

export default class EventCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: new Date(),
      events: [],
      page: 1,
      total_pages: 0,
      loading: true
    };
  }

  componentDidMount() {
    this.fetchAllPages();
  }

  fetchAllPages = () => {
    this.fetchEvents(this.state.page);
  };

  fetchEvents = (page) => {
    const url = `${getLocationOrigin()}/tournament/list_events_for_cm/?page=${page}`;
    const options = { ...defaultOptions };

    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        const merged = [...this.state.events, ...data.events];

        this.setState(
          {
            events: merged,
            total_pages: data.total_pages,
            page: page,
            loading: false
          },
          () => {
            if (this.state.page < this.state.total_pages) {
              this.fetchEvents(this.state.page + 1);
            }
          }
        );
      })
      .catch(error => {
        console.log("Calendar fetch error:", error);
      });
  };

  monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const days = [];

    for (let i = 0; i < firstDay; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) days.push(i);
    while (days.length < 42) days.push(null);

    return days;
  };

  getEventDatesForMonth = (date) => {
    const { events } = this.state;
    const year = date.getFullYear();
    const month = date.getMonth();

    return events.flatMap(event => {
      if (!event.start_date) return [];

      const start = new Date(event.start_date);
      const end = event.end_date ? new Date(event.end_date) : start;

      const dates = [];

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        if (d.getFullYear() === year && d.getMonth() === month) {
          dates.push(d.getDate());
        }
      }

      return dates;
    });
  };

  isToday = (day) => {
    if (!day) return false;

    const today = new Date();
    const { currentDate } = this.state;

    return (
      today.getDate() === day &&
      today.getMonth() === currentDate.getMonth() &&
      today.getFullYear() === currentDate.getFullYear()
    );
  };

  previousMonth = () => {
    const { currentDate } = this.state;
    this.setState({
      currentDate: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1
      )
    });
  };

  nextMonth = () => {
    const { currentDate } = this.state;
    this.setState({
      currentDate: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1
      )
    });
  };

  renderSkeleton = () => {
    return (
      <div>
        <div className="ec-header">
          <div className="ec-skel ec-skel-title" />
          <div className="ec-nav">
            <div className="ec-skel ec-skel-btn" />
            <div className="ec-skel ec-skel-btn" />
          </div>
        </div>

        <div className="ec-weekdays">
          {Array.from({ length: 7 }).map(function(_, i) {
            return <div key={i} className="ec-weekday"><div className="ec-skel ec-skel-weekday" /></div>;
          })}
        </div>

        <div className="ec-grid">
          {Array.from({ length: 42 }).map(function(_, i) {
            return <div key={i} className="ec-day ec-skel ec-skel-day" style={{ animationDelay: (i * 0.015) + "s" }} />;
          })}
        </div>
      </div>
    );
  };

  render() {
    const { currentDate, loading } = this.state;
    const days = this.getDaysInMonth(currentDate);
    const eventDates = this.getEventDatesForMonth(currentDate);

    return (
      <div className="ec-container">
        {loading ? (
          this.renderSkeleton()
        ) : (
          <div>
            <div className="ec-header">
              <h2 className="ec-title">
                {this.monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
              </h2>

              <div className="ec-nav">
                <button className="ec-btn" onClick={this.previousMonth}>
                  &#8249;
                </button>
                <button className="ec-btn" onClick={this.nextMonth}>
                  &#8250;
                </button>
              </div>
            </div>

            <div className="ec-weekdays">
              {this.daysOfWeek.map(day => (
                <div key={day} className="ec-weekday">{day}</div>
              ))}
            </div>

            <div className="ec-grid">
              {days.map((day, idx) => {
                const isEvent = day && eventDates.includes(day);
                const isToday = this.isToday(day);

                return (
                  <div
                    key={idx}
                    className={[
                      "ec-day",
                      day     ? "ec-active" : "",
                      isEvent ? "ec-event"  : "",
                      isToday ? "ec-today"  : ""
                    ].join(" ").trim()}
                  >
                    {day}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div className="ec-legend">
          <div className="ec-legend-item">
            <div className="ec-legend-box"></div>
            <span>Event Day</span>
          </div>
          <div className="ec-legend-item">
            <div className="ec-today-box"></div>
            <span>Today</span>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/components/EventCalendar/Calendar.new.js